import { DateTime } from 'luxon'

const conversions = {
  ae: 'ä|æ|ǽ',
  oe: 'ö|œ',
  ue: 'ü',
  a: 'à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª',
  c: 'ç|ć|ĉ|ċ|č',
  d: 'ð|ď|đ',
  e: 'è|é|ê|ë|ē|ĕ|ė|ę|ě',
  g: 'ĝ|ğ|ġ|ģ',
  h: 'ĥ|ħ',
  i: 'ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı',
  j: 'ĵ',
  k: 'ķ',
  l: 'ĺ|ļ|ľ|ŀ|ł',
  n: 'ñ|ń|ņ|ň|ŉ',
  o: 'ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º',
  r: 'ŕ|ŗ|ř',
  s: 'ś|ŝ|ş|š|ſ',
  t: 'ţ|ť|ŧ',
  u: 'ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ',
  y: 'ý|ÿ|ŷ',
  w: 'ŵ',
  z: 'ź|ż|ž',
  ss: 'ß',
  ij: 'ĳ',
  f: 'ƒ'
}

export default {
  methods: {
    getLocale (locale) {
      switch (locale) {
        case 'de': {
          return 'de-DE'
        }
        default:
          return 'en-US'
      }
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return `${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} €`
    },
    isScheduled (date) {
      const publishDate = DateTime.fromISO(date)
      const currentDate = DateTime.local()
      const diff = currentDate.diff(publishDate).toObject()
      return diff.milliseconds < 0
    },
    centToEuro (value, format) {
      const euro = value / 100
      return format ? this.formatPrice(euro) : euro
    },
    euroToCent (value) {
      return value * 100
    },
    amountFormatted (value) {
      return this.centToEuro(value, true)
    },
    getStatusTagClass (status) {
      let tagClass = 'is-dark'
      if (status === 'published') tagClass = 'is-success'
      return tagClass
    },
    getDateTagClass (status) {
      let tagClass = ''
      if (status === 'scheduled') tagClass = 'is-warning'
      if (status === 'published') tagClass = 'is-light'
      return tagClass
    },
    getTranslation (key, options) {
      return this.$i18n.t(key, options)
    },
    urlSlug (str) {
      if (!str) return 'no-title'

      let formatted = str.toLowerCase()
      for (const i in conversions) {
        formatted = formatted.replace(new RegExp(conversions[i], 'g'), i)
      }
      formatted = formatted.replace(/[^\w ]+/g, '').replace(/ +/g, '-')
      return formatted
    },
    percentage (value, total) {
      if (value) {
        return Math.round((value / total) * 100)
      }
      return 0
    },
    relativePercentage(values, value) {
      const total = values.reduce((acc, val) => acc + val.count, 0)
      return this.percentage(value, total)
    },
    getLocalizedUrl (path) {
      if (!window) return path

      const protocol = window.document.location.protocol
      let hostLocale
      let host
      const result = window.document.location.host.match(/^([A-Za-z]{2})\./)
      if (result && result[1]) {
        hostLocale = result[1]
        host = window.document.location.host.split(result[0])[1]
      }

      if (!host && !hostLocale && this.$i18n.locale !== 'en') {
        return `${protocol}//${this.$i18n.locale}.${
          window.document.location.host
        }${path}`
      }

      if (host && hostLocale && hostLocale !== this.$i18n.locale) {
        return `${protocol}//${
          this.$i18n.locale !== 'en' ? this.$i18n.locale + '.' : ''
        }${host}${path}`
      }

      return path
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/common.js